/**
 * The year, for copyright lines.
 *
 * It lives here because three footers wanted it and each had its own answer:
 * one defined it privately, one had it commented out while still calling it,
 * and the one actually rendered on the site had the year typed in by hand and
 * had gone stale.
 */
export function getCurrentYear(): number {
  return new Date().getFullYear();
}
